<!--
 * @Author: your name
 * @Date: 2021-05-19 17:07:01
 * @LastEditTime: 2021-09-15 11:56:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ope\src\views\content\yirongtongShop\components\yrtBanner.vue
-->
<template>
  <section class="control_box">
     <el-dialog
      :append-to-body="true"
      title="轮播图管理"
      width="800px"
      :visible.sync="dialogVisible"
      @close='closeDialog'>
      <div>
        <div class="margin-b10">
            <el-button @click.native.prevent="showDialog('新增')"  type="primary">新增</el-button>
      </div>
       <el-table :data="bannerList"  border >
        <el-table-column type="index" label="序号" align="center"  width="50"></el-table-column>
        <el-table-column  prop="imgUrl" label="图片预览" align="center" >
          <template slot-scope="scope">
             <el-image style="width: 60px; height: 30px" :src="scope.row.imgUrl" :preview-src-list="scope.row.imgUrl.split(',')" fit="scale-down"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="轮播图名称" align="center"  ></el-table-column>
        <el-table-column prop="linkUrl" label="跳转链接" align="center"  ></el-table-column>
      
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click.native.prevent="showDialog('编辑',scope.row,scope.$index )"  type="text">编辑</el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index, bannerList)" type="text">删除</el-button>
            <el-button @click.native.prevent="up(scope.$index)" icon="el-icon-top" type="text">上移</el-button>
            <el-button @click.native.prevent="down(scope.$index)" icon="el-icon-bottom" type="text">下移</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tip-list">
          <p>1.轮播图名称不可重复。</p>
          <p>2.轮播图图片建议尺寸为1200px×470px，最多9张，仅支持上传.jpg/.jpeg/.png格式的图片，每张 大小不超过1M</p>
          <p>3.跳转链接请直接从易派客前台相关页面复制，域名开头必须为https://XXXXXX.epec.com。</p>
      </div>
      </div>
      <div slot="footer" class="dialog-footer flex-c">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>

  <!-- 新增/编辑轮播图 -->
<el-dialog  :append-to-body="true" :title="dialogTitle" :visible.sync="dialogFormVisible" width="560px">
  <el-form :model="formData" :rules="rules" ref="ruleForm"  label-width="100px">
    <el-form-item label="轮播图名称:"  prop="name">
      <el-input v-model.trim="formData.name"></el-input>
    </el-form-item>
    <el-form-item label="轮播图:" prop="imgUrl">
       <el-upload
          class="oneimg-upload"
          :action="uploadImgUrl"
          :headers="header"
          :show-file-list="false"
          :before-upload="beforeImgUpload"
          :on-success="handleImgSuccess"
          accept=".jpeg,.jpg,.png">
          <el-image v-if="formData.imgUrl" :src="formData.imgUrl" fit="fill" ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
           <div class="tips" slot="tip">轮播图尺寸需为宽1200px、高470px，仅支持jpg、png格式，图片不得超过1M</div>
      </el-upload>
    </el-form-item>
    <el-form-item label="跳转链接:"  >
      <el-input v-model.trim="formData.linkUrl"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer flex-c">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
  </div>
</el-dialog>
  <!-- 新增/编辑轮播图 -->
  </section>
</template>

<script> 
import { epecToken } from "../../utils/globalData";
import api from '../../api/cms/index'
import utils from "../..//utils/utils";
export default {
     props:{
        activeName: {
            type: String,
            default: ''
        },
         bannerList: {
          type: Array,
          default: function () {
          
            return []
          }
        },
        
  },
  watch: {
        activeName(newV,oldV) {
            console.log(newV,oldV)
            this.dialogVisible= newV=='banner'?true:false
        } 
  },
    data(){
      
      return {
        header:epecToken,
        dialogVisible:false,
        rules: {
          name: [
            { required: true, message: '请填写名称', trigger: 'blur' }
          ],
          imgUrl: [
            { required: true, message: '请上传banner图', trigger: 'blur' }
          ],
           
        },
        dialogFormVisible:false,
 
        dialogTitle:'',
        activeInde:'',
        formData:{
          name:'',
          imgUrl:'',
          linkUrl:'',
        }
      }
    },
    created(){
      this.uploadImgUrl=api.fileUpload
    },
    methods:{
        closeDialog(){
            this.$parent.choosenComments('');
        },
       
     
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      
      showDialog(type,row,index){
        this.dialogTitle=type;
        this.dialogFormVisible=true;
        if(type==='编辑'){
          this.activeInde=index;
          this.formData={
            imgUrl:row.imgUrl,
            linkUrl:row.linkUrl,
            name:row.name
          }
           
        }else{
          this.formData={
            imgUrl:'',
            linkUrl:'',
            name:'',
 
          }
        }
      },
      up(index) {
            if(index === 0) {
              return
            }
            //在上一项插入该项
            this.bannerList.splice(index - 1, 0, (this.bannerList[index]))
            //删除后一项
            this.bannerList.splice(index + 1, 1)
 
        },
      down(index) {
          if (index === (this.bannerList.length-1)) {
            return
          }
          // 在下一项插入该项
          this.bannerList.splice(index + 2, 0, (this.bannerList[index]))
          // 删除前一项
          this.bannerList.splice(index, 1)
      },
      handleImgSuccess(res, file) {
          console.log(file)
          if(res.success){
              this.formData.imgUrl=res.data.url;
              this.$message.success('上传成功！');
          }
      },
      beforeImgUpload(file) {
           
                const isMaxsize = file.size / 1024 / 1024 < 1;
                let parmas={
                    file:file,
                    typeArr:['image/jpeg', 'image/png'],
                    imgMessage:'上传图片只能是jpg或者png格式!',
                    isMaxsize:isMaxsize,
                    sizeMessage:'上传图片大小不能超过1M!',
                    maxWidth:1200,
                    maxHeight:470
                }
                return utils.checkImgupload(parmas)
            },


 
       submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.dialogTitle=='新增'){
              this.bannerList.push(this.formData)
            }else if(this.dialogTitle=='编辑'){
              this.bannerList.splice(this.activeInde, 1, {...this.formData});
            }
            
            this.dialogFormVisible=false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
}
</script>

<style lang='scss' scoped>
@import '../../../../assets/css/theme.scss';
.control_box{
 
  background: #fff;
  .box-card-header{
    font-weight: 600;
  
  }
}
.tip-list{
  background: #F4F7FF;
  padding:10px;
  margin-top: 10px;
  p{
    color:$c6;
    line-height: 32px;
  }
}

 .oneimg-upload{
    width: 389px;
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
  }
  .oneimg-upload ::v-deep .el-upload--text{
    width: 387px;
    height:180px;
    line-height: 180px;
    border: 1px dashed #d9d9d9;
    .el-image{
      height:100%;
    }
  }
</style>

 
